import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isInversorAuthenticated } from '../utils/authSession';

export default function PrivateInversorRoute({ children }) {
  const location = useLocation();
  if (!isInversorAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
